import { defineTextStyles } from '@chakra-ui/react';
/**
 * Text Styles - Typography styles from Figma UI kit
 */

export const textStyles = defineTextStyles({
  h1: {
    semibold: {
      description: 'Heading 1 Semibold',
      value: {
        fontFamily: 'main',
        fontSize: '3xl',
        fontWeight: 'semibold',
        lineHeight: '120',
        letterSpacing: 'none',
      },
    },
    medium: {
      description: 'Heading 1 Medium',
      value: {
        fontFamily: 'main',
        fontSize: '3xl',
        fontWeight: 'medium',
        lineHeight: '120',
        letterSpacing: 'none',
      },
    },
  },
  h2: {
    semibold: {
      description: 'Heading 2 Semibold',
      value: {
        fontFamily: 'main',
        fontSize: '2xl',
        fontWeight: 'semibold',
        lineHeight: '120',
        letterSpacing: 'none',
      },
    },
    medium: {
      description: 'Heading 2 Medium',
      value: {
        fontFamily: 'main',
        fontSize: '2xl',
        fontWeight: 'medium',
        lineHeight: '120',
        letterSpacing: 'none',
      },
    },
  },
  h3: {
    semibold: {
      description: 'Heading 3 Semibold',
      value: {
        fontFamily: 'main',
        fontSize: 'xl',
        fontWeight: 'semibold',
        lineHeight: '120',
        letterSpacing: 'none',
      },
    },
    medium: {
      description: 'Heading 3 Medium',
      value: {
        fontFamily: 'main',
        fontSize: 'xl',
        fontWeight: 'medium',
        lineHeight: '120',
        letterSpacing: 'none',
      },
    },

    regular: {
      description: 'Heading 3 Regular',
      value: {
        fontFamily: 'main',
        fontSize: 'xl',
        fontWeight: 'regular',
        lineHeight: '120',
        letterSpacing: 'none',
      },
    },
  },

  h4: {
    semibold: {
      description: 'Heading 4 Semibold',
      value: {
        fontFamily: 'main',
        fontSize: 'l',
        fontWeight: 'semibold',
        lineHeight: '130',
        letterSpacing: 'none',
      },
    },
    medium: {
      description: 'Heading 4 Medium',
      value: {
        fontFamily: 'main',
        fontSize: 'l',
        fontWeight: 'medium',
        lineHeight: '130',
        letterSpacing: 'none',
      },
    },
    regular: {
      description: 'Heading 4 Regular',
      value: {
        fontFamily: 'main',
        fontSize: 'l',
        fontWeight: 'regular',
        lineHeight: '130',
        letterSpacing: 'none',
      },
    },
  },
  h5: {
    medium: {
      description: 'Heading 5 Medium',
      value: {
        fontFamily: 'main',
        fontSize: 'm',
        fontWeight: 'medium',
        lineHeight: '130',
        letterSpacing: 'none',
      },
    },
    regular: {
      description: 'Heading 5 Regular',
      value: {
        fontFamily: 'main',
        fontSize: 'm',
        fontWeight: 'regular',
        lineHeight: '130',
        letterSpacing: 'none',
      },
    },
  },
  h6: {
    medium: {
      description: 'Heading 6 Medium',
      value: {
        fontFamily: 'main',
        fontSize: 's',
        fontWeight: 'medium',
        lineHeight: '130',
        letterSpacing: 'none',
      },
    },
    regular: {
      description: 'Heading 6 Regular',
      value: {
        fontFamily: 'main',
        fontSize: 's',
        fontWeight: 'regular',
        lineHeight: '130',
        letterSpacing: 'none',
      },
    },
  },
  body: {
    m: {
      medium: {
        description: 'Body Medium',
        value: {
          fontFamily: 'main',
          fontSize: 'm',
          fontWeight: 'medium',
          lineHeight: '140',
          letterSpacing: 'none',
        },
      },
      regular: {
        description: 'Body Regular',
        value: {
          fontFamily: 'main',
          fontSize: 'm',
          fontWeight: 'regular',
          lineHeight: '140',
          letterSpacing: 'none',
        },
      },
      italic: {
        description: 'Body Italic',
        value: {
          fontFamily: 'main',
          fontSize: 'm',
          fontWeight: 'regular',
          lineHeight: '140',
          fontStyle: 'italic',
        },
      },
    },
    s: {
      medium: {
        description: 'Body Medium',
        value: {
          fontFamily: 'main',
          fontSize: 's',
          fontWeight: 'medium',
          lineHeight: '140',
          letterSpacing: 'none',
        },
      },
      regular: {
        description: 'Body Regular',
        value: {
          fontFamily: 'main',
          fontSize: 's',
          fontWeight: 'regular',
          lineHeight: '140',
          letterSpacing: 'none',
        },
      },
    },
    xs: {
      regular: {
        description: 'Body Regular',
        value: {
          fontFamily: 'main',
          fontSize: 'xs',
          fontWeight: 'regular',
          lineHeight: '140',
          letterSpacing: 'none',
        },
      },
      medium: {
        description: 'Body Medium',
        value: {
          fontFamily: 'main',
          fontSize: 'xs',
          fontWeight: 'medium',
          lineHeight: '140',
          letterSpacing: 'none',
        },
      },
    },
  },
  button: {
    s: {
      description: 'Button sm label',
      value: {
        fontFamily: 'main',
        fontSize: 's',
        fontWeight: 'regular',
        lineHeight: '14px',
        letterSpacing: 'none',
      },
    },
    m: {
      description: 'Button md label',
      value: {
        fontFamily: 'main',
        fontSize: 'm',
        fontWeight: 'regular',
        lineHeight: '16px',
        letterSpacing: 'none',
      },
    },
  },
  label: {
    xs: {
      regular: {
        description: 'Label Regular',
        value: {
          fontFamily: 'main',
          fontSize: 'xs',
          fontWeight: 'regular',
          lineHeight: '140',
          letterSpacing: 'none',
        },
      },
      medium: {
        description: 'Label Medium',
        value: {
          fontFamily: 'main',
          fontSize: 'xs',
          fontWeight: 'medium',
          lineHeight: '140',
          letterSpacing: 'none',
        },
      },
    },
  },
  richText: {
    m: {
      regular: {
        description: 'Body Regular',
        value: {
          fontFamily: 'body',
          fontSize: 'm',
          fontWeight: 'regular',
          lineHeight: '140',
          letterSpacing: 'none',
        },
      },
    },
    s: {
      regular: {
        description: 'Body Regular',
        value: {
          fontFamily: 'body',
          fontSize: 's',
          fontWeight: 'regular',
          lineHeight: '140',
          letterSpacing: 'none',
        },
      },
    },
  },
});
